/*
 * @Author: zhouwei
 * @Date: 2020-05-26 15:37:01
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-05-29 13:01:21
 * @Desc: 点击/拖拽上传组件
*/
<template>
  <div class="drag-upload">
    <div
      ref="selectFrame"
      class="select-frame"
    >
      <input
        ref="file"
        title=""
        type="file"
        class="file"
        :accept="accept"
        @change="fileChange"
      />
      <img src="@assets/images/shape.png" />
      <span class="txt">点击或将文件拖拽到这里上传</span>
    </div>
    <div
      v-if="file"
      class="show-file"
    >
      <div class="file-content">
        <div class="con">
          <ds-iconfont
            icon-class="icon-mk-annex"
            class="icon"
          />
          <div class="txt">
            {{ file.name }}
          </div>
        </div>
        <ds-iconfont
          class="close"
          icon-class="icon-ds-guanbi1"
          @click="clear"
        />
      </div>
      <mk-progress :percentage="percentage" />
    </div>
  </div>
  <!-- <el-upload
    class="upload-demo"
    drag
    action=""
    multiple
  >
    <div style="width: 200px; height: 200px; background:skyblue;"></div>
  </el-upload> -->
</template>
<script>
export default {
  name: 'DragUpload',
  props: {
    accept: {
      type: String,
      default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    tips: {
      type: String,
      default: '请上传XLSX类型文件'
    },
    limitSize: {
      type: [Number, String],
      default: 5
    }
  },
  data () {
    return {
      file: '',
      percentage: 0
    }
  },
  mounted () {
    this.drag()
  },
  methods: {
    /* 拖拽事件 */
    drag () {
      this.$refs.selectFrame.ondragleave = (e) => {
        e.preventDefault() // 阻止离开时的浏览器默认行为
      }
      this.$refs.selectFrame.ondrop = (e) => {
        // 只获取第一项
        e.preventDefault() // 阻止拖放后的浏览器默认行为
        const data = e.dataTransfer.files // 获取文件对象
        if (data.length < 1) {
          return // 检测是否有文件拖拽到页面
        }
        if (data[0].name.indexOf('.xlsx') === -1) {
          this.$message({
            type: 'error',
            message: this.tips,
            showClose: true
          })
        } else if (data[0].size > this.limitSize * 1024 * 1024) {
          this.$message({
            type: 'error',
            message: `请上传${this.limitSize}MB以内的文件`,
            showClose: true
          })
        } else {
          this.file = e.dataTransfer.files[0]
          this.percentage = 100
          this.$emit('upload-success', this.file)
        }
      }
      this.$refs.selectFrame.ondragenter = (e) => {
        e.preventDefault() // 阻止拖入时的浏览器默认行为
      }
      this.$refs.selectFrame.ondragover = (e) => {
        e.preventDefault() // 阻止拖来拖去的浏览器默认行为
      }
    },
    /* 文件上传change事件 */
    fileChange (e) {
      let file = e.target.files[0]
      if (file.name.indexOf('.xlsx') > 0) {
        if (file.size > this.limitSize * 1024 * 1024) {
          this.$message({
            type: 'error',
            message: `请上传${this.limitSize}MB以内的文件`,
            showClose: true
          })
        } else {
          this.file = file
          this.percentage = 100
          this.$emit('upload-success', this.file)
        }
      } else {
        this.$message({
          type: 'error',
          message: this.tips,
          showClose: true
        })
      }
    },
    /* 清除file文件 */
    clear () {
      this.file = ''
      this.$refs.file.value = ''
      this.$emit('clear')
    }
  }
}
</script>
<style lang="scss" scoped>
.drag-upload {
  width: 386px;
  margin: 0 auto;

  .select-frame {
    width: 100%;
    height: 195px;
    background: rgba(0, 0, 0, 0.02);
    cursor: pointer;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-top: 6px;
    position: relative;

    &:hover {
      border-color: #009cff;
    }

    img {
      display: block;
      width: 48px;
      height: 48px;
      margin-bottom: 20px;
    }

    .txt {
      font-size: 16px;
      color: #262626;
      text-align: center;
    }

    .file {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }

  .show-file {
    width: 386px;
    margin: 0 auto;
    margin-top: 20px;

    .file-content {
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .con {
        height: 22px;
        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .icon {
          font-size: 14px;
          color: #8c8c8c;
        }

        .txt {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin: 0 8px 0 8px;
          color: #8c8c8c;
        }
      }

      .close {
        color: #8c8c8c;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
